import { Container, Row, Col, Button } from "react-bootstrap";
import { FaPhone, FaWhatsapp, FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
import { SiTiktok } from "react-icons/si";

const Footer = () => {
  const socials = [
    {
      icon: FaFacebook,
      color: "#1877f2",
      name: "Facebook",
      link: "https://www.facebook.com/adifyofficialpk",
    },
    {
      icon: FaInstagram,
      color: "#e4405f",
      name: "Instagram",
      link: "https://www.instagram.com/aidifyofficial/",
    },
    {
      icon: SiTiktok,
      color: "#000000",
      name: "TikTok",
      link: "https://www.tiktok.com/@aidifyofficial",
    },
    {
      icon: FaYoutube,
      color: "#ff0000",
      name: "YouTube",
      link: "https://www.youtube.com/@adifiyofficial",
    },
  ];

  return (
    <footer
      className="py-5 position-relative overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
      }}
    >
      <Container className="position-relative">
        <Row className="align-items-center g-5">
          {/* Left Side - CTA Content */}
          <Col lg={6} className="pe-lg-5">
            <div className="text-white text-start">
              <h2 className="display-5 fw-bold mb-4">Ready to Get Started?</h2>
              <p
                className="fs-5 mb-5 opacity-90"
                style={{ lineHeight: "1.6" }}
              >
                Join thousands of satisfied patients who trust us with their
                Aidify needs
              </p>

              <div className="d-flex flex-column flex-sm-row gap-3">
                <a href="tel:+923001243439">
                  <Button
                    size="lg"
                    variant="light"
                    className="px-5 py-3 rounded-pill fw-bold"
                    style={{
                      // boxShadow: "0 8px 25px rgba(0, 0, 0, 0.2)",
                      transform: "translateY(0)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-3px)";
                      // e.target.style.boxShadow =
                      //   "0 12px 35px rgba(0, 0, 0, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      // e.target.style.boxShadow =
                      //   "0 8px 25px rgba(0, 0, 0, 0.2)";
                    }}
                  >
                    <FaPhone className="me-2" style={{ color: "#0891b2" }} />
                    <span style={{ color: "#0891b2" }}> +92 300 1243439</span>
                  </Button>
                </a>
                <a href="https://wa.me/923001243439">
                  <Button
                    size="lg"
                    className="px-5 py-3 rounded-pill "
                    style={{
                      background: "linear-gradient(135deg, #25d366 0%, #128c7e 100%)",
                      // boxShadow: "0 8px 25px rgba(0, 0, 0, 0.2)",
                      transform: "translateY(0)",
                      transition: "all 0.3s ease",
                      fontWeight: "649",
                      border: "none",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-3px)";
                      // e.target.style.boxShadow =
                      //   "0 12px 35px rgba(0, 0, 0, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      // e.target.style.boxShadow =
                      //   "0 8px 25px rgba(0, 0, 0, 0.2)";
                    }}
                  >
                    <FaWhatsapp className="me-2" style={{color:"#ffffff"}} />
                    <span style={{color:"#ffffff"}}> +92 300 1243439</span>
                  </Button>
                </a>
               
              </div>
            </div>
          </Col>

          {/* Right Side - Social Media + Email */}
          <Col lg={6} className="ps-lg-5 text-start text-lg-end">
            <div className="text-white">
              {/* Social Media */}
              <div className="mb-5">
                <h4 className="fw-bold mb-4 text-start text-lg-end">
                  {/* Aidify | Simply Satisfy */}
                  <br />
                  <span className="fw-normal">Follow us on social media</span>
                </h4>

                <div className="d-flex gap-4 justify-content-start justify-content-lg-end">
                  {socials.map(({ icon: Icon, color, name, link }, index) => (
                    <a
                      key={index}
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={name}
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: "60px",
                        height: "60px",
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        backdropFilter: "blur(10px)",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        color: "white",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = color;
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow = `0 10px 30px ${color}40`;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor =
                          "rgba(255, 255, 255, 0.1)";
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      <Icon size={24} />
                    </a>
                  ))}
                </div>
              </div>

              {/* Email */}
              {/* <div>
                <div className="d-flex align-items-center justify-content-start justify-content-lg-end">
                  <div className="text-end me-3">
                    <div className="fw-bold fs-5">Email Us</div>
                    <a
                      href="mailto:contact@aidify.com"
                      className="text-white text-decoration-none opacity-90"
                      style={{ fontSize: "1.2rem" }}
                    >
                      contact@aidify.com
                    </a>
                  </div>
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: "55px",
                      height: "55px",
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                  >
                    <FaEnvelope size={22} />
                  </div>
                </div>
              </div> */}
            </div>
          </Col>
        </Row>

        {/* Bottom Copyright */}
        <Row className="mt-5">
          <Col className="text-center text-white opacity-75">
            © {new Date().getFullYear()} Aidify — Simply Satisfy. All rights reserved.
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
